<template>
  <div class="app">
    <div v-if="showCookie" class="cookie">
      <div class="cookie__inner">
        <div class="cookie__text">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.9987 26.6654C21.8897 26.6654 26.6654 21.8897 26.6654 15.9987C26.6654 10.1077 21.8897 5.33203 15.9987 5.33203C10.1077 5.33203 5.33203 10.1077 5.33203 15.9987C5.33203 21.8897 10.1077 26.6654 15.9987 26.6654Z"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M16.0118 20.0001L16.0141 16"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M16 12.668L16 12.0013"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <p>
            האתר/מערכת עושה שימוש ב-cookies. כדי לספק לך חווית גלישה טובה יותר,
            וכן למטרות סטטיסטיקה, איפיון ושיפורים.
          </p>
          <p>
            למידע על cookies ועל מדיניות הפרטיות המעודכנת
            <a href="https://www.smart-campus.co.il/privacy/" target="_blank"
              >יש ללחוץ כאן</a
            >.
          </p>
        </div>
        <a
          href=""
          class="btn btn--border-white btn--static-lg"
          @click.prevent="hideCookie"
        >
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11 1L1 11"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M1 1L11 11"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          סגור
        </a>
      </div>
    </div>
    <pwa v-if="showPwa" />

    <component
      :is="layout"
      v-if="
        layout === 'auth-layout' || layout === 'guest-layout'
          ? true
          : selectedCampus
      "
      :class="{ 'show-pwa': showPwa }"
    >
      <router-view v-show="loaded" />
    </component>
  </div>
</template>

<script>
import store from './Store/index';
import router from './Router/index';
import axios from 'axios';
import { mapGetters, mapMutations, mapState } from 'vuex';
import LayoutDefault from './Components/Layout/LayoutDefault';
import AuthLayout from './Components/Layout/AuthLayout';
import GuestLayout from './Components/Layout/GuestLayout.vue';
import PDFLayout from './Components/Layout/PDFLayout';
import StudentLayout from './Pages/Student/Blocks/StudentLayout';
import LessonsPdf from '@/Components/Layout/LessonsPdf';
import Pwa from './Components/Pwa';

export default {
  name: 'App',
  components: {
    LayoutDefault,
    StudentLayout,
    AuthLayout,
    PDFLayout,
    GuestLayout,
    LessonsPdf,
    Pwa
  },
  data() {
    return {
      // loaded: this.getLoading ? this.getLoading : false,
      loaded: true,
      vh: '',
      vw: ''
    };
  },
  computed: {
    ...mapState({
      showCookie: s => s.settings.showCookie,
      showPwa: s => s.settings.showPwa,
      selectedCampus: s => s.settings.selectedCampus
    }),
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
      getLoading: 'preloader/getLoading'
    }),
    layout() {
      return this.$route.meta.layout || 'layout-default';
    }
  },
  watch: {
    getLoading(value) {
      this.loaded = value;
    },
    $route(to, from) {
      // if (this.user && this.user.is_first_login) {
      //   this.$router.replace({
      //     name: 'FirstChangePassword'
      //   });
      // }
      /*
                                if(to.name !== from.name){
                                    this.loaded = false;
                                    setTimeout(res => {
                                        this.loaded = true;
                                    }, 500);
                                }
                */
    }
  },
  mounted() {
    this.vh = window.innerHeight * 0.01;
    this.vw = window.innerWidth * 0.01;

    document.documentElement.style.setProperty('--vh', `${this.vh}px`);
    document.documentElement.style.setProperty('--vw', `${this.vw}px`);

    if (this.user && this.user.is_first_login) {
      this.$router.replace({
        name: 'FirstChangePassword'
      });
    }
    axios.interceptors.response.use(
      undefined,
      function (err) {
        return new Promise((resolve, reject) => {
          console.log(this.$route.name, 'this.$route.name');
          if (
            err.response.status === 401 &&
            this.$route.name !== 'OpenPageLessonGroupEdit'
          ) {
            store.dispatch('auth/logOut');
            router.push({ name: 'SignIn' });
          }
          throw err;
        });
      }.bind(this)
    ); // Здесь привязываем контекст
  },
  methods: {
    ...mapMutations({
      hideCookie: 'settings/HIDE_COOKIE'
    })
  }
};
</script>
<style>
[v-cloak] {
  display: none;
}
</style>
